<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Alta de Psicólogo</h1>
      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area" style="background-color:#bebebc">
            <div class="row">
              <div class="col-4">
                <h4>Datos del Psicólogo</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>
            <div class="row">
              <div class="col-5"></div>
              <div class="col-5" style="padding-right:0px;">
                <input v-model="textoBusqueda" type="text" class="form-control campos" placeholder="Busqueda" v-on:keyup.enter="buscarCuentas" />
              </div>
              <div class="col-2" style="padding-left:5px;">
                <input type="button" value="Buscar" class="form-control" style="background-color:var(--verde-pj-100); color: var(--blanco-pj)" @click="buscarCuentas" />
              </div>
            </div>
            <div class="row fondo-gris new-row">
              <table class="table table-striped table-light table-hover"
                     id="tablaCuentas">
                <thead style="background-color:#004746">
                  <tr>
                    <th>Nombre</th>
                    <th>Cuenta de Usuario</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-for="infoCuenta in infoCuentas">
                    <td>{{infoCuenta.Nombre}} {{infoCuenta.ApellidoPaterno}} {{infoCuenta.ApellidoMaterno}}</td>
                    <td>{{ infoCuenta.Email }}</td>
                    <td>
                      <i class="fas fa-user"
                         @click="seleccionarCuenta(infoCuenta)"
                         title="Seleccionar Usuario" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row new-row">
              <div class="col-4">
                <span class="input-label font-black">Cuenta De Usuario</span>
              </div>
              <div class="col-8">
                <span class="input-label font-black">Nombre Completo</span>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <input v-model="this.usuario" type="text" class="form-control camposBloqueados" readonly />
              </div>
              <div class="col-8">
                <input v-model="this.nombreCompleto" type="text" class="form-control camposBloqueados" readonly />
              </div>
            </div>
            <div class="row new-row">
              <div class="col-4">
                <span class="input-label font-black">Color Distintivo</span>
              </div>
              <div class="col-4">
                <span class="input-label font-black">Localidad</span>
              </div>
              <div class="col-4">
                <span class="input-label font-black">Título Profesional</span>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <input v-model="colorDistintivo" type="color" class="form-control campos" />
              </div>
              <div class="col-4">
                <input v-model="localidad" type="text" class="form-control campos" />
              </div>
              <div class="col-4">
                <input v-model="tituloProfesional" type="text" class="form-control campos" />
              </div>
            </div>
            <div class="row new-row">
              <div class="col-4">
                <span class="input-label font-black">Cédula Profesional</span>
              </div>
              <div class="col-4">
                <span class="input-label font-black">Ubicación</span>
              </div>              
            </div>
            <div class="row">
              <div class="col-4">
                <input v-model="cedulaProfesional" type="text" class="form-control campos" />
              </div>
              <div class="col-8">
                <input v-model="ubicacion" type="text" class="form-control campos" />
              </div>
            </div>
            <div class="row">
              <div class="col-12"><hr /></div>
            </div>
            <div class="row new-row">
              <div class="col-10"></div>
              <div class="col-2">
                <input type="button" value="Guardar" class="form-control" style="background-color:#004746" v-bind:disabled="deshabilitarBoton" @click="finalizar" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  export default {
    props: {
      idPsicologo:{
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        textoBusqueda: "",
        nombreCompleto: "",
        usuario: "",
        cuentaId: null,
        colorDistintivo: null,
        infoCuentas: [],
        NumeroFilasPagina: 3,
        localidad: "",
        tituloProfesional: "",
        cedulaProfesional: "",
        ubicacion: ""
      }
    },
    components: {
    },
    methods: {
      buscarCuentas: function () {
        var peticion = {
          "esPrueba": false,
          "textoBusqueda": this.textoBusqueda
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.ObtenerCuentas, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.infoCuentas = response.data.Usuarios_DBCuentas            

            this.$nextTick(() => {
              PaginarTabla('tablaCuentas', this.NumeroFilasPagina)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      altaPsicologo: function () {
        var peticion = {
          "esPrueba": false,
          "usuarioId": this.cuentaId,
          "colorDistintivo": this.colorDistintivo,
          "Localidad": this.localidad,
          "TituloProfesional": this.tituloProfesional,
          "CedulaProfesional": this.cedulaProfesional,
          "Ubicacion": this.ubicacion
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.AltaPsicologo, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null)
            this.buscarCuentas();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      editarPsicologo: function () {
        var peticion = {
          "esPrueba": false,
          "PsicologoId": this.idPsicologo,
          "UsuarioId": this.cuentaId,
          "ColorDistintivo": this.colorDistintivo
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.EditarPsicologo, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null)
            this.buscarCuentas();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      seleccionarCuenta: function (infoCuenta) {
        this.nombreCompleto = infoCuenta.Nombre + " " + infoCuenta.ApellidoPaterno + " " + infoCuenta.ApellidoMaterno
        this.usuario = infoCuenta.Email;
        this.cuentaId = infoCuenta.IdUsuario;
      },
      verificarPsicologoId: function () {
        if (this.idPsicologo != 0 && this.idPsicologo != null) {
          this.cargarInfoPsicologo(this.idPsicologo);
        }
      },
      finalizar: function () {
        if (this.idPsicologo != 0 && this.idPsicologo != null) {
          this.editarPsicologo();
        } else {
          this.altaPsicologo();
        }
      },
      cargarInfoPsicologo: function () {
        var peticion = {
          "esPrueba": false,
          "PsicologoId": this.idPsicologo
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.ObtenerPsicologo, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response.data)
            var psicologo = response.data.Psicologo;
            this.nombreCompleto = psicologo.CuentaUsuario.Nombre + " " + psicologo.CuentaUsuario.ApellidoPaterno + " " + psicologo.CuentaUsuario.ApellidoMaterno
            this.usuario = psicologo.CuentaUsuario.Email;
            this.cuentaId = psicologo.CuentaUsuario.IdUsuario;
            this.colorDistintivo = psicologo.ColorDistintivo;
            this.localidad = psicologo.Localidad;
            this.tituloProfesional = psicologo.TituloProfesional;
            this.cedulaProfesional = psicologo.CedulaProfesional;
            this.ubicacion = psicologo.Ubicacion;

          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }
      
    }, computed: {
      deshabilitarBoton: function () {
        return this.usuario == "" || this.cuentaId == null || this.colorDistintivo == null || this.localidad == "" || this.tituloProfesional == "" || this.cedulaProfesional == "" || this.ubicacion == ""
      }
    }, mounted: function mounted() {
      this.verificarPsicologoId()
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }
  .fondo-gris{
    height:300px;
    background-color:#504f54;
  }
  .input-label {
    font-size:18px;
  }
  .form-control:disabled, .form-control[readonly] {
    background-color: #504f54;
  }
  .campos{
  background-color: white;
  color: black;
  }
  .font-black{
    color: black;
  }
  .camposBloqueados{
    background-color: lightgray;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/SIPSIC/Administracion/Psicologos/AltaDePsicologo.vue